import { selectComponentState } from 'projectRedux/store';
import { eppMaterialAdapter } from '../adapters/eppMaterialAdapter';

export const {
  selectAll: selectAllEppMaterials,
  selectById: selectEppMaterialById,
  selectEntities: selectEppMaterialEntities,
} = eppMaterialAdapter.getSelectors((state) => selectComponentState(state).eppMaterials);
